// extracted by mini-css-extract-plugin
module.exports = {"snackbarContainer":"snackbar_snackbarContainer__NaFIv"};